import { PublicLayout } from "../components/layout/PublicLayout";

export default function Service() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <div className="mb-8 border-b border-slate-200 pb-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="personaw logo" className="h-10 w-10 object-contain rounded-lg shadow-sm" />
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Terms of Service</h1>
              <p className="mt-1 text-xs font-medium text-slate-500">Last updated: September 25, 2025</p>
            </div>
          </div>
        </div>

        <div className="space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <section className="space-y-2">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">1. Purpose</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              These Terms govern the use of the AI-powered career platform provided by personaw ("Service"), including usage conditions, procedures, and the rights and obligations between users and the Service.
            </p>
          </section>

          <section className="space-y-3 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">2. Service Description</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              The Service provides the following features:
            </p>
            <ul className="list-disc space-y-1.5 pl-5 text-sm text-slate-700 sm:text-base">
              <li>AI-powered Persona profile generation</li>
              <li>AI resume & cover letter writing assistance</li>
              <li>Team-fit matching service</li>
              <li>AI chat interview & dual report</li>
              <li>Company talent discovery & culture matching</li>
            </ul>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">3. Account Registration</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              Registration is completed via Google OAuth login. Users under the age of 14 are not permitted to use the Service.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">4. Paid Services & Refunds</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              Paid plans are processed through Paddle. You can cancel your subscription at any time and continue using the service until the end of the current billing period. Refunds for change of mind are available within 7 days of payment.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">5. Prohibited Activities</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              Users must not: impersonate others or submit false information; resell AI-generated content for commercial purposes without authorization; or interfere with the normal operation of the Service.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">6. Limitation of Liability</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              AI-generated content (resumes, interview reports, etc.) is provided as reference material and does not guarantee employment outcomes. The Service is not liable for agreements between users or between users and companies.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">7. Changes to Terms</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              The Service may update these Terms as needed. Changes will be announced through in-app notifications or email prior to taking effect.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">8. Contact</h2>
            <p className="text-sm text-slate-700 sm:text-base">
              Service inquiries:{" "}
              <a href="mailto:support@personaw.com" className="font-semibold text-teal hover:underline">
                support@personaw.com
              </a>
            </p>
          </section>
        </div>

        <div className="mt-8 flex justify-start">
          <a
            href="/"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 transition hover:text-navy"
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </PublicLayout>
  );
}
